import { render, staticRenderFns } from "./InclusiveNode.vue?vue&type=template&id=c025e730&scoped=true"
import script from "./InclusiveNode.vue?vue&type=script&lang=js"
export * from "./InclusiveNode.vue?vue&type=script&lang=js"
import style0 from "./InclusiveNode.vue?vue&type=style&index=0&id=c025e730&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c025e730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c025e730')) {
      api.createRecord('c025e730', component.options)
    } else {
      api.reload('c025e730', component.options)
    }
    module.hot.accept("./InclusiveNode.vue?vue&type=template&id=c025e730&scoped=true", function () {
      api.rerender('c025e730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/nodes/InclusiveNode.vue"
export default component.exports